import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";
import Unauthorized from "../general/Unauthorized";

function Especialidades() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');
    let userdata = [];
    let clientData = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const [toastMsg, setToastMsg] = useState('');

    const cols = [
        { name:'Nombre', selector:row => row.nombre, sortable:true },
        { name:'Acción', cell:row => getBotones(row), minWidth: '20%' }
    ];

    const getBotones = (item) => {
        
        return (
            <>
            <Link to={'/especialidad?id='+item.id} className="btn btn-primary btn-sm"><i className="far fa-edit"></i>&nbsp;Editar</Link>&nbsp;
            <Link to={'#'} onClick={() => showModal(item.id)} className="btn btn-outline-danger btn-sm"><i className="fas fa-trash-alt"></i>&nbsp;Eliminar</Link>
            </>
        )
    }

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a administrar personal y proveedores
        const tienePermiso = userdata.up && userdata.up.includes('administrarPersonalProveedores');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);
        
        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });


        axios.get('/especialidades?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    
                    setItems(response.data);
                    console.log(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });
    },[]);


    const eliminar = (e) => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            params: {
                id: e
            }
        }
        
        axios.delete('/especialidad?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setItems([]);
                    let nuevoItems = items;
                    let nombreItem = "";

                    nuevoItems.map((item) => {
                        if (item.id==e) {
                            nombreItem = item.nombre;
                            const i = nuevoItems.indexOf(item);
                            if (i > -1) {
                                nuevoItems.splice(i, 1);
                            }
                        }
                    });

                    setItems(nuevoItems);
                    cerrar();

                    setToastMsg('La especialidad '+nombreItem+' ha sido eliminada');
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const showModal = (e) => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(e);
    }

    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        setIdItemEliminar(null);
    }

    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            params: {
                uid: userdata.user_id,
                termino: terminoBusqueda
            }
        }

        axios.get('/especialidades',config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error);
            })

    },[terminoBusqueda]);


    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Especialidades</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Especialidades</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">
                            
                        <div className="row">
                            <div className="col-md-9">
                                <Link to="/nueva-especialidad" className="btn btn-primary">Crear Nueva</Link>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Buscar</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                
                                <DataTable
                                columns={cols}
                                data={items}
                                pagination
                                paginationComponentOptions={{
                                    rowsPerPageText: 'Filas por página:',
                                    rangeSeparatorText: 'de',
                                    noRowsPerPage: false,
                                    selectAllRowsItem: true,
                                    selectAllRowsItemText: 'Todos'
                                }}
                                noDataComponent="No hay registros para mostrar"
                                id={'especialidades'}
                                />

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>

                <div className={'modal-container modal fade in '+modalContainerStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h4 className="modal-title">Eliminar</h4>
                                <button type="button" className="close" onClick={() => cerrar()}>&times;</button>
                            </div>

                            <div className="modal-body">
                                ¿Esta Seguro Que Desea Eliminar La Opcion Seleccionada?
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => cerrar()}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={() => eliminar(idItemEliminar)}>Eliminar</button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={'modal-backdrop fade '+modalBackdropStatus}></div>
                
                <Footer showToast={false} delay={0} message={toastMsg} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default Especialidades;